import { render, staticRenderFns } from "./preViewFileCommonDialog.vue?vue&type=template&id=5f2dbed4&scoped=true&"
import script from "./preViewFileCommonDialog.vue?vue&type=script&lang=js&"
export * from "./preViewFileCommonDialog.vue?vue&type=script&lang=js&"
import style0 from "./preViewFileCommonDialog.vue?vue&type=style&index=0&id=5f2dbed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2dbed4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f2dbed4')) {
      api.createRecord('5f2dbed4', component.options)
    } else {
      api.reload('5f2dbed4', component.options)
    }
    module.hot.accept("./preViewFileCommonDialog.vue?vue&type=template&id=5f2dbed4&scoped=true&", function () {
      api.rerender('5f2dbed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/preViewFileCommonDialog.vue"
export default component.exports